'use client';

import { env } from '@/utils/env';
import { noop } from 'es-toolkit';
import { useReportWebVitals as useReportWebVitalsNext } from 'next/web-vitals';

/**
 * Hook to report web vitals metrics in development environment
 * Only reports metrics when NEXT_PUBLIC_ENV is set to 'LOCAL'
 */
export const useReportWebVitalsHook = () => {
  useReportWebVitalsNext((metric) => {
    switch (metric.name) {
      case 'CLS':
        console.debug('[web-vitals] CLS:', metric);
        break;
      case 'FID':
        console.debug('[web-vitals] FID:', metric);
        break;
      case 'LCP':
        console.debug('[web-vitals] LCP:', metric);
        break;
      case 'FCP':
        console.debug('[web-vitals] FCP:', metric);
        break;
      case 'TTFB':
        console.debug('[web-vitals] TTFB:', metric);
        break;
      case 'INP':
        console.debug('[web-vitals] INP:', metric);
        break;
      default:
        console.debug('[web-vitals] default', metric);
        break;
    }
  });
};

/**
 * Hook to report web vitals metrics in development environment.
 * Only reports metrics when NEXT_PUBLIC_ENV is set to 'LOCAL'.
 */
export const useReportWebVitals = env('NEXT_PUBLIC_ENV') === 'LOCAL' ? useReportWebVitalsHook : noop;
